<script setup lang="ts">
  import { UiButton, FormFieldContainer, useToastStore } from '@logistiek-zonder-papier/lzp-library'
  import { useFlowConfigStore } from '@/store/flow-config.store'
  import { computed } from 'vue'

  const { currentPage, fieldId } = defineProps<{
    currentPage: number
    fieldId: string
  }>()

  const toastStore = useToastStore()
  const flowConfigStore = useFlowConfigStore()
  const currentFields = computed(() => flowConfigStore.config?.pages[currentPage]?.fields ?? [])

  const currentIndex = computed(() => currentFields.value.findIndex(field => field.id === fieldId))

  async function move(direction: number) {
    const index = currentFields.value.findIndex(field => field.id === fieldId)
    if (index === -1) return

    const newIndex = index + direction
    if (newIndex < 0 || newIndex >= currentFields.value.length) return

    const item = currentFields.value[index]
    if (!item) return

    currentFields.value.splice(index, 1)
    currentFields.value.splice(newIndex, 0, item)
    await flowConfigStore.syncAllFieldOrders(newIndex)

    toastStore.success(`Field updated successfully.`)
  }
</script>

<template>
  <FormFieldContainer label="Field Order">
    <div class="button-container">
      <UiButton
        variant="prominent"
        icon="chevronUp"
        size="small"
        :disabled="currentIndex < 1"
        @click="move(-1)"
      />
      <UiButton
        variant="prominent"
        icon="chevronDown"
        size="small"
        :disabled="currentIndex === currentFields.length - 1"
        @click="move(1)"
      />
    </div>
  </FormFieldContainer>
</template>

<style scoped lang="css">
  .button-container {
    display: flex;
    gap: var(--spacing-xs);
  }
</style>
